import React, { useEffect, useState, useRef } from "react";
import Button from "react-bootstrap/esm/Button";
import Card from "react-bootstrap/esm/Card";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import toast, { Toaster } from "react-hot-toast";
import BackToGameList from "../../utils/BackToGameList";

function CountTiles() {
  const [number, setNumber] = useState(8);
  const [count, setCount] = useState(0);
  const [incorrectCount, setincorrectCount] = useState(0);
  const [time, setTime] = useState(60);
  const [numbers, setNumbers] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [guess, setGuess] = useState();
  const [play, setPlay] = useState(false);
  const [gO, setGO] = useState(false);
  const [intervalID, setIntervalID] = useState();

  const tileRef = useRef([]);

  const startGame = () => {
    setCount(0);
    setPlay(true);
    setGO(false);
    for (let i = 0; i < number; i++) {
      numbers.push(
        <Col key={i} xs={3} style={{ textAlign: "center" }}>
          <Button
            key={i}
            style={{
              margin: "10px",
              width: "100px",
            }}
            onClick={() => setGuess(i)}
            ref={(ref) => (tileRef[i] = ref)}
          >
            {i + 1}
          </Button>
        </Col>
      );
    }
    setButtons(
      numbers
        .map((numberButton) => {
          return { value: numberButton, id: Math.random() };
        })
        .sort((a, b) => a.id - b.id)
        .map((n) => {
          return n.value;
        })
    );
  };

  const numCheck = (z) => {
    if (z !== undefined && z !== null && z !== "newGame") {
      if (z === count) {
        toast("Congratulations, you've selected the correct answer!", {
          duration: 5000,
          position: "bottom-center",
        });
        tileRef[z].style.backgroundColor = "green";
        tileRef[z].style.border = "green 1px solid";
        setCount((prevCount) => prevCount + 1);
      } else {
        toast("Sorry but that is incorrect. Please try again!", {
          duration: 5000,
          position: "bottom-center",
        });
        setincorrectCount((prevCount) => prevCount + 1);
      }
    }
    setGuess("newGame");
  };

  useEffect(() => {
    numCheck(guess);
  }, [guess]);

  useEffect(() => {
    if (count === number) {
      setPlay(false);
      toast(
        "Congratulations, you've completed the game! Click the Restart button to do it all again. Number of incorrect attempts: " +
          incorrectCount,
        {
          duration: 5000,
          position: "bottom-center",
        }
      );
      setTime(60);
      setNumbers([]);
    }
  }, [count]);

  useEffect(() => {
    if (play) {
      const intervalId = setInterval(() => {
        if (play) {
          setTime((prevSeconds) => prevSeconds - 1);
        }
      }, 1000);
      setIntervalID(intervalId);
      return () => clearInterval(intervalId);
    }
  }, [play]);

  const gameOver = () => {
    setTime(60);
    setNumbers([]);
    setPlay(false);
    setGO(true);
  };

  useEffect(() => {
    if (time <= 0) {
      gameOver();
    }
  }, [time]);

  return (
    <>
      <BackToGameList />
      {numbers.length < 1 ? (
        <Card style={{ marginTop: "50px" }}>
          <Card.Header style={{ textAlign: "center", fontSize: "24px" }}>
            <b>Count Tiles</b>
          </Card.Header>
          <Card.Body style={{ textAlign: "center" }}>
            {gO
              ? `Looks like you ran out of time! Don't fret, to play again touch the Restart Game button below. Select the tiles in order
              starting from 1. Select all the numbers in order to win!`
              : count === 0
              ? `To play touch the Start Game button below. Select the tiles in order
            starting from 1. Select all the numbers in order to win!`
              : `To play again touch the Restart Game button below. Select the tiles in order
            starting from 1. Select all the numbers in order to win!`}
            <br />
            <Button onClick={startGame}>
              {count === 0 ? "Start Game" : "Restart Game"}
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <Card style={{ marginTop: "50px" }}>
          <Row>
            <Col style={{ textAlign: "center" }}>Time Remaining: {time}</Col>
          </Row>
          <Row>{buttons}</Row>
          <Col style={{ fontSize: "25px", textAlign: "center" }}>
            Current: {count}
          </Col>
        </Card>
      )}
    </>
  );
}

export default CountTiles;
